const Pagination = (($) => {

    const NAME = 'pagination';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        anchorClass: '',
        first: '&#8606;',//'&laquo;',
        firstClass: '',
        hideOnlyOnePage: true,
        href: false,
        initiateStartPageClick: false,
        last: '&#8608;',//'&raquo;',
        lastClass: '',
        next: '&rarr;',//'&rsaquo;',
        nextClass: '',
        pageClass: '',
        pageVariable: 'PageNumber',
        paginationClass: 'pagination',
        prev: '&larr;',//'&lsaquo;',
        prevClass: '',
        startPage: 1,
        target: null,
        totalPages: 1,
        url: false,
        visiblePages: 5,
        success: null
    };
    const Selector = {
        PAGINATION: `.js-${NAME}`
    };

    class Pagination {
        constructor(element, config) {
            this._config = config;
            this._element = element;

            if (this._config.target && this._config.url) {
                $(this._element).on('page', (event, page) => this._onPageClick(event, page));
            }
        }

        _onPageClick(event, page) {
            const regex = new RegExp(`${this._config.pageVariable}=*[^&#]*`);
            $.get(this._config.url.replace(regex, `${this._config.pageVariable}=${page - 1}`), (data) => {
                $(this._config.target).html(data);
                if (this._config.success) {
                    $.getFunction(this._config.success)(data, page);
                }
            });
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }


        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Pagination(this, config);
                    $this.data(DATA_KEY, data).twbsPagination(config);
                }
            });
        }
    }

    $(() => Pagination._jQueryInterface.call($(Selector.PAGINATION)));
    $(document).ajaxStop(() => Pagination._jQueryInterface.call($(Selector.PAGINATION)));

    $.fn[NAME] = Pagination._jQueryInterface;
    $.fn[NAME].Constructor = Pagination;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Pagination._jQueryInterface;
    }

    return Pagination;
})(jQuery);